import React, { PureComponent, Fragment } from 'react';
import ReactDOM from 'react-dom';

import ChoroplethMapWidget from '~/core/scripts/widgets/ChoroplethMapWidget';
import Switch from '~/core/scripts/components/Switch';

import '../styles/index.styl';

const basemapAttribution = 'Karte: <a href="https://www.openstreetmap.org/copyright" target="_blank">© OpenStreetMap contributors</a>';

const colorConfigs = {
  'value_fsme': [
    [0, '#ffeee6'],
    [1, '#ffc2bb'],
    [1.5, '#fc9392'],
    [2.5, '#e8696f'],
    [5, '#c94353'],
    [10, '#a1273d'],
    [25, '#701a2d'],
    [54]
  ],
  'value_bor': [
    [0, '#ddf9f6'],
    [61, '#acdce4'],
    [123, '#80becf'],
    [194, '#57a0b9'],
    [274, '#3382a0'],
    [350, '#136485'],
    [434, '#004769'],
    [627]
  ]
};


class TickMap extends PureComponent {
  state = {
    valueKey: 'value_fsme'
  };

  toggleLayers = () => {
    const { valueKey } = this.state;

    if (valueKey === 'value_fsme') {
      this.showBorLayer();
    } else {
      this.showFSMELayer();
    }
  }

  showFSMELayer = () => {
    this.setState({ valueKey: 'value_fsme' });
  }

  showBorLayer = () => {
    this.setState({ valueKey: 'value_bor' });
  }

  render() {
    const { valueKey } = this.state;
    const colorSteps = colorConfigs[valueKey];
    const legendMinLabel = colorSteps[0][0];
    const legendMaxLabel = colorSteps[colorSteps.length - 1][0];
    const showHatch = valueKey === 'value_fsme';

    return (
      <Fragment>
        <div className="map-controls">
          <div className="map-controls__inner">
            <div onClick={this.showFSMELayer} className="switch-label left">
              <div className="switch-label__img"><img src="images/minimap_fsme.png" /></div>
              <div className="switch-label__text"><strong>FSME</strong> Karte</div>
            </div>
            <Switch checked={valueKey === 'value_bor'} onChange={checked => checked ? this.showBorLayer() : this.showFSMELayer()} />
            <div onClick={this.showBorLayer} className="switch-label right">
              <div className="switch-label__text"><strong>Borreliose</strong> Karte</div>
              <div className="switch-label__img"><img src="images/minimap_bore.png" /></div>
            </div>
          </div>
        </div>
        <ChoroplethMapWidget
          minZoom={5}
          maxZoom={14}
          choroplethSource="data/data.topo.json"
          overlaySource="data/data.topo.json"
          overlayDissolveKey="sub"
          hatchSource="data/risk-fsme.topo.json"
          showHatch={showHatch}
          showBasemap
          basemapUrl="https://tiles.interaktiv.cloud.funkedigital.de/light-labels/{z}/{x}/{y}.png"
          basemapAttribution={basemapAttribution}
          showGeocoder
          valueKey={valueKey}
          colorSteps={colorSteps}
          showLegend
          legendMinLabel={legendMinLabel}
          legendMaxLabel={legendMaxLabel}
          showLabels
          labelPreset="germanStates"
          customLabels={[
            ['Risikogebiet', 49.9608884,9.9265173, 0, 20, 'risk-label']
          ]}
          searchPresets={[{ name: 'Berlin', locationId: 'NT_42hE.hM0X.5u5FeSNmJOJC' },{ name: 'Jena', locationId: 'NT_nkqUjVLSkFzSYlvEIqjIzD' },{ name: 'Konstanz', locationId: 'NT_0K6DUgsO-cRknli9NjMMnB' }]}
          searchPresetsTitle="Zum Beispiel:"
          smoothFactor={0.5}
          zoomDelta={1}
          zoomSnap={0.2}
        >
        </ChoroplethMapWidget>
      </Fragment>
    );
  }
}

function init() {
  ReactDOM.render(<TickMap />, document.getElementById('map'));
}

export default {
  init
}